import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/orders/orders";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u062f\u0631\u06cc\u0627\u0641\u062a \u0633\u0641\u0627\u0631\u0634\u200c\u0647\u0627";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getOrders() {
  return request("/");
}
